if (!customElements.get('f-special-discount-goal')) {
  class FSpecialDiscountGoal extends HTMLElement {
    constructor() {
      super()

      this.leftToSpend = this.querySelector('[data-left-to-spend]')
      this.goal = Number(this.dataset.cartGoal) * Number(window.Shopify.currency.rate || 1) || 0
      this.moneyFormat = window.FoxThemeSettings.money_format
      this.enableConfetti = this.dataset.enableConfetti === 'true'
      this.confettiShow = false
      this.goalDone = false
    }

    connectedCallback() {
      this.updateGoal(Number(this.dataset.cartTotal))

      this.cartUpdatedUnsubscriber = window.FoxThemeEvents.subscribe('ON_CART_UPDATED', () => {
        this.updateFromRenderedCart()
      })
      this.itemAddedUnsubscriber = window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', () => {
        this.updateFromRenderedCart()
      })

      this.confettiShow = this.goalDone
    }

    disconnectedCallback() {
      if (this.cartUpdatedUnsubscriber) this.cartUpdatedUnsubscriber()
      if (this.itemAddedUnsubscriber) this.itemAddedUnsubscriber()
    }

    updateFromRenderedCart() {
      queueMicrotask(() => {
        const cartContainer = this.closest('cart-drawer') || this.closest('.main-cart-items-section') || document
        const qualifyingLines = cartContainer.querySelectorAll('[data-special-discount-line-total]')
        const qualifyingTotal = Array.from(qualifyingLines).reduce((total, line) => {
          return total + (Number(line.dataset.specialDiscountLineTotal) || 0)
        }, 0)

        this.updateGoal(qualifyingTotal)
      })
    }

    updateGoal(totalInCents) {
      const cartTotal = totalInCents / 100
      const goalLeft = this.goal - cartTotal
      const goalDone = goalLeft <= 0
      const percent = this.goal > 0 ? Math.min((cartTotal * 100) / this.goal, 100) : 0

      this.classList.toggle('hidden', totalInCents <= 0)
      this.classList.toggle('f-cartgoal--done', goalDone)
      this.classList.toggle('shakeY', goalDone)
      this.style.setProperty('--progress', `${percent}%`)
      this.dataset.total = cartTotal

      if (!goalDone && this.leftToSpend) {
        this.leftToSpend.innerHTML = formatMoney(goalLeft * 100, this.moneyFormat)
      }

      if (goalDone && !this.goalDone && this.enableConfetti) {
        this.showConfetti()
      } else if (!goalDone) {
        this.confettiShow = false
      }

      this.goalDone = goalDone
    }

    showConfetti() {
      const cartDrawer = this.closest('.f-cart-drawer__inner')
      if (!this.confettiShow && cartDrawer) {
        setTimeout(() => {
          new window.FoxTheme.Confetti(cartDrawer)
          this.confettiShow = true
        }, 800)
      }
    }
  }

  customElements.define('f-special-discount-goal', FSpecialDiscountGoal)
}